import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

export const processCateringManualOrder = async (orderData) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.PROCESS_CATERING_MANUAL_ORDER,
      orderData
    );
    return response;
  } catch (error) {
    console.error("Error processing catering manual order:", error);
    throw error;
  }
};
